import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="404-page">
            <Seo title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
            <div className="text-center max-w-2xl">
                <div className="font-mono text-xs uppercase tracking-widest text-clay mb-6">[ Error · 404 ]</div>
                <h1 className="font-serif text-8xl lg:text-9xl leading-none text-forest tracking-tight">Not <em className="italic">found.</em></h1>
                <p className="mt-8 text-inkgreen/80 text-lg">The page you're looking for doesn't exist — but there's a factory full of paper bowls that do.</p>
                <div className="mt-10 flex gap-3 justify-center flex-wrap">
                    <Link to="/" className="btn-pill btn-solid" data-testid="404-home">Back to Home →</Link>
                    <Link to="/products/paper-salad-bowls" className="btn-pill">See our products</Link>
                </div>
            </div>
        </div>
    );
}
